import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-analysis-list-subject-home',
    templateUrl: './analysis-list-subject-home.component.html',
    styleUrls: ['./analysis-list-subject-home.component.scss']
})
export class AnalysisListSubjectHomeComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
